import React from 'react';
import PartnerPanel from './partner-panel/PartnerPanel';

const Partner = () => {
  return <PartnerPanel />;
};

export default Partner;
